/**
 * Prepare headers for a nib api request. Use this when setting up a base query with fetchBaseQuery
 */
export const prepareHeaders = (headers: Headers) => {
  headers.set('Accept', 'application/json');
  headers.set('X-NibNZ-Version', '1');
  return headers;
};
